// Vee-validate configuration and global validators
// Docs - https://vee-validate.logaretm.com/v4/
import {defineRule} from "vee-validate";
import {max, max_value, min, min_value, regex, required, url, email} from "@vee-validate/rules";
import {stringHasContent} from "@/helpers/functions/string";
import I18n from "@/modules/i18n";


defineRule('required', required);
defineRule('max', max);
defineRule('min', min);
// min/max validate string length; these compare the number itself.
defineRule('max_value', max_value);
defineRule('min_value', min_value);
defineRule('regex', regex);
defineRule('url', url);
defineRule('email', email);

//TODO re-evaluate these rules
defineRule("comes_after", (value, [begin, end]) => {
    if ((begin && end) && begin > end) {
        return I18n.global.t('endDateNotBeforeStart');
    }
    return true;
});
defineRule("req_if_end", (value, [begin, end]) => {
    if ((begin && end) && end.length > 0 && begin.length === 0) {
        return 'Geef een begindatum op';
    }
    return true;
});
defineRule("req_if_begin", (value, [begin, end]) => {
    if ((begin && end) && begin.length > 0 && end.length === 0) {
        return 'Geef een einddatum op';
    }
    return true;
});
defineRule("both_set", (value, [otherValue]) => {
    const hasValue = value && value.length > 0;
    const hasOtherValue = otherValue && otherValue.length > 0;

    if ((!hasValue && hasOtherValue)) {
        //TODO: make translatable
        return 'Voor het toevoegen van een knop zijn zowel de knoptekst als de link verplicht.';
    } else {
        return true;
    }
});

defineRule('all_set', (value, [target, target2, target3]) => {
    const hasTargetValue = stringHasContent(target) || stringHasContent(target2) || stringHasContent(target3);
    console.log(hasTargetValue)

    if (stringHasContent(value) && !hasTargetValue) {
        //TODO: make translatable
        return 'Voor het toevoegen van een knop zijn zowel de knoptekst als de link verplicht.';
    }
    return true;
});

defineRule('atLeastOneOfTwo', (value, [otherFieldName, fieldLabel, otherFieldLabel], ctx) => {
    const otherFieldValue = ctx.form[otherFieldName];

    if (value || otherFieldValue) {
        return true;
    }

    return I18n.global.t(
        'atLeastOneOfTwo',
        {
            fieldLabel,
            otherFieldLabel,
        });
});

defineRule('atLeastOneMultilingualField', (value, [baseName, languagesString, fieldLabel], ctx) => {
    // Convert the comma-separated string back to an array
    const languages = languagesString.split('-');

    // Check if at least one language field has a value
    const hasValue = languages.some(lang => {
        const fieldName = `${baseName}${lang}`;
        const fieldValue = ctx.form[fieldName];
        return fieldValue && fieldValue.trim().length > 0;
    });

    if (hasValue) {
        return true;
    }

    if (languages.length === 1) {
        return I18n.global.t('requiredField', { fieldLabel });
    }

    return I18n.global.t('atLeastOneMultiLingualFieldRequired', { fieldLabel });
});
